import type { SearchVehicle, InventoryTableRow } from './dto.inventory';

/**
 * Transform SearchVehicle from Auctus API to InventoryTableRow for the table
 * @param vehicle - SearchVehicle from the vehicle search API
 * @returns Formatted table row
 */
export const transformSearchVehicleToRow = (vehicle: SearchVehicle): InventoryTableRow => {
  const { vehicleConfig, metadata } = vehicle;

  return {
    vin: metadata.vin,
    webLink: metadata.acWebUrl || '',
    batchNumber: metadata.batchNumber,
    availability: metadata.availability || '',
    locationName: metadata.locationName || '',
    city: metadata.city || '',
    country: metadata.country || '',
    model: vehicleConfig.model?.localizedName || vehicleConfig.model?.name || '',
    trim: vehicleConfig.variant?.localizedName || vehicleConfig.variant?.name || '',
    drivetrain: vehicleConfig.driveTrain?.localizedName || vehicleConfig.driveTrain?.name || '',
    exteriorColor:
      vehicleConfig.exteriorColor?.localizedName || vehicleConfig.exteriorColor?.name || '',
    exteriorColorCode: vehicleConfig.exteriorColor?.code || '',
    interiorColor:
      vehicleConfig.interiorColor?.localizedName || vehicleConfig.interiorColor?.name || '',
    interiorColorCode: vehicleConfig.interiorColor?.code || '',
    appearance: vehicleConfig.appearance?.localizedName || vehicleConfig.appearance?.name || '',
    appearanceCode: vehicleConfig.appearance?.code || '',
    roof: vehicleConfig.roof?.localizedName || vehicleConfig.roof?.name || '',
    wheels: vehicleConfig.wheels?.localizedName || vehicleConfig.wheels?.name || '',
    wheelsCode: vehicleConfig.wheels?.code || '',
    year: String(metadata.modelYear),
    adas: vehicleConfig.dreamDrive?.localizedName || vehicleConfig.dreamDrive?.name || '',
    adasCode: vehicleConfig.dreamDrive?.code || '',
    soundSystem: vehicleConfig.soundSystem?.localizedName || vehicleConfig.soundSystem?.name || '',
    soundSystemCode: vehicleConfig.soundSystem?.code || '',
    frontSeats: vehicleConfig.frontSeats?.localizedName || vehicleConfig.frontSeats?.name || '',
    frontSeatsCode: vehicleConfig.frontSeats?.code || '',
    rearSeats: vehicleConfig.rearSeats?.localizedName || vehicleConfig.rearSeats?.name || '',
    comfortPackage:
      vehicleConfig.comfortConvenience?.localizedName ||
      vehicleConfig.comfortConvenience?.name ||
      '',
    packages: vehicleConfig.techPackage?.localizedName || vehicleConfig.techPackage?.name || '',
    packagesCode: vehicleConfig.techPackage?.code || '',
    dynamicHandlingPackage:
      vehicleConfig.dynamicPackage?.localizedName || vehicleConfig.dynamicPackage?.name || '',
    technologyPackage:
      vehicleConfig.techPackage?.localizedName || vehicleConfig.techPackage?.name || '',
    towingPackage:
      vehicleConfig.towingPackage?.localizedName || vehicleConfig.towingPackage?.name || '',
    uuid: metadata.uuid || '',
    shortCode: metadata.shortCode || '',
    condition: 'new', // Default - search API doesn't return condition
    price: metadata.totalPrice,
  };
};

/**
 * Transform array of SearchVehicle to table data
 * @param vehicles - Array of SearchVehicle from API
 * @returns Array of formatted table rows
 */
export const transformSearchVehicles = (vehicles: SearchVehicle[]): InventoryTableRow[] => {
  return vehicles.map(transformSearchVehicleToRow);
};
